import { ISeries } from '.';
import { ILogger, LoggerFactory } from '../../../helpers/helpers';

export class FakeSeries implements ISeries {
    name: string;
    private _color: string;
    private _legendText: string;
    private _isVisible: boolean;
    private _legendAttributes: any;
    private _identifier: string;
    private _logger: ILogger;

    constructor(name: string, color: string) {
        this._color = color;
        this.name = name;
        this.init();
    }

    private init() {
        this._logger = LoggerFactory.getLogger('WideTech.Charting.FakeSeries');
    }

    color(value?: string): string {
        if (arguments.length) {
            this._color = value;
        }
        return this._color;
    }

    legendText(text?: string): string {
        return this.name;
    }

    isVisible(value?: boolean): boolean {
        if (arguments.length) {
            this._isVisible = value;
        }
        return this._isVisible;
    }

    legendAttributes?(values?: any) {
        if (arguments.length) {
            this._legendAttributes = values;
        }
        return this._legendAttributes;
    }

    update(): void {
        //
    }

    data(value?: any[]): any[] {
        return [];
    }

    translate(translateX: number, translateY: number) {
        return null;
    }

    selector(value?: (d: any) => any): (d: any) => any {
        return null;
    }

    identifier(value?: any) {
        if (arguments.length) {
            this._identifier = value;
        }
        return this._identifier;
    }

    crosshairLabel(bisect: any, date: any, valueFormatter: any) {
        return null;
    }

    remove() {
        //
    }

    min(): number {
        return 0;
    }

    max(): number {
        return 1;
    }

    isStacked(value?: boolean): boolean {
        return false;
    }

    isXAxis(value?: boolean): boolean {
        return false;
    }
    
    private _ratio: number = 1;
    ratio(): number;
    ratio(value: number): this;
    ratio(value?: number) {
        if (arguments.length) {
            this._ratio = value;
            return this;
        }
        return this._ratio;
    }
}
